export const FETCH_EXCHANGE_LIST = 'withdrawal/FETCH_EXCHANGE_LIST';
export const FETCH_WITHDRAWL_INFO = 'withdrawal/FETCH_WITHDRAWL_INFO';
export const EXCHANGE = 'withdrawal/EXCHANGE';
export const FETCH_USER_EMAIL_VERIFY = 'withdrawal/FETCH_USER_EMAIL_VERIFY';



// WEBPACK FOOTER //
// ./src/app/redux/front/withdrawal/types.js